/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const dependencyEdgeEntrySchema = z.object({
  predecessorItemId: z.int(),
  predecessorName: z.string().nullish(),
  successorItemId: z.int(),
  successorName: z.string().nullish(),
});
